/**
 * Check if token exist or not, if not redirect back to login page
 */
export default function auth({next, router, to, store}) {

  const token = store.getters['auth/token'];
  const role = store.getters['auth/role'];
  if ( !token || role != 'reseller') {
    store.dispatch('snackbar/setSnackbar', {
      message: "Unauthorized. Redirecting...",
      type: "warning"
    });
    store.dispatch('clearAppData');
    return router.push({ name: 'Login' });
  } 
  return next();
}